var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-format-trade"},_vm._l((_vm.product_formats.dp),function(product,index){return _c('product-format',{key:index,attrs:{"product":product,"trade":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }